import moment from 'moment-timezone'
import React from 'react'
import {
  StructuredTableColumn,
  StructuredTaskDataTable,
  StructuredTaskSection,
} from '../../../../common/components/StructuredTaskDetails'
import { Resource } from '../../../../common/constants/resource'
import { MIBIAI } from '../../../tasks/types/mib'
import {
  dateToString,
  NORA_DISPLAY_DATE_FORMAT,
  valueToString,
} from '../../utilities/formattingUtilities'

export const RenderMIBIAISection = (mibIAIs: MIBIAI[]) => {
  const formattedTableData = formatData(mibIAIs)
  const columns: StructuredTableColumn[] = [
    {
      key: Resource.MIB_IAI_DATE_KEY,
      label: Resource.MIB_IAI_DATE,
    },
    {
      key: Resource.MIB_IAI_INQUIRY_KEY,
      label: Resource.MIB_IAI_INQUIRY,
    },
    {
      key: Resource.MIB_IAI_LINE_KEY,
      label: Resource.MIB_IAI_LINE,
    },
    {
      key: Resource.MIB_IAI_TYPE_KEY,
      label: Resource.MIB_IAI_TYPE,
    },
    {
      key: Resource.MIB_IAI_STATUS_KEY,
      label: Resource.MIB_IAI_STATUS,
    },
    {
      key: Resource.MIB_IAI_COVERAGE_KEY,
      label: Resource.MIB_IAI_COVERAGE,
    },
    {
      key: Resource.MIB_IAI_CARRIER_KEY,
      label: Resource.MIB_IAI_CARRIER,
    },
    {
      key: Resource.MIB_IAI_RELATION_KEY,
      label: Resource.MIB_IAI_RELATION,
    },
  ]

  return (
    <StructuredTaskSection title={Resource.MIB_IAI_SUBTITLE}>
      <StructuredTaskDataTable
        columns={columns}
        rows={formattedTableData}
        rowKey={(_, index) => `mib-iai-row-${index}`}
      />
    </StructuredTaskSection>
  )
}

function formatData(mibIAIs: MIBIAI[]) {
  const formattedTableData = mibIAIs.map((mibIAI) => ({
    date: dateToString(mibIAI.date),
    inquiry: mibIAI.inquiry,
    line: mibIAI.line,
    type: mibIAI.type,
    status: mibIAI.status,
    coverage: valueToString(mibIAI.coverage),
    carrier: mibIAI.carrier,
    relation: mibIAI.relation,
  }))
  formattedTableData.sort((a, b) =>
    moment(b.date, NORA_DISPLAY_DATE_FORMAT).diff(
      moment(a.date, NORA_DISPLAY_DATE_FORMAT),
    ),
  )
  return formattedTableData
}
